<template>
  <div class="main">
   
    <nightRecordList ref="nightRecordList" noModel></nightRecordList>
  </div>
</template>
<script>
import nightRecordList from "./forms/nightRecordList.vue";
export default {
  components: { nightRecordList },
  data() {
    return {};
  },
  mounted() {
    var obj = {
      name: "1230",
      docId: "",
    };
    this.$refs.nightRecordList.reach(obj);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/yhgl/xunchajilu.vue